import React from 'react';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { makeStyles } from '@material-ui/core/styles';

import { gql, useMutation } from '@apollo/client';
import { useRailsContextApolloData } from 'appDir/lib/apollo/customHooks';
import { useDispatch } from 'react-redux';
import { CircularLoading } from 'appDir/lib/components/Loading';
import { toastServerError } from 'appDir/lib/functions/toastError';
import { blueGrey } from '@material-ui/core/colors';

const SET_EDIT_PREVIEW = gql`
  mutation SetEditPreview($userIsPreviewing: Boolean!) {
    setEditPreview(userIsPreviewing: $userIsPreviewing) {
      userIsPreviewing
    }
  }
`;

const highlightColor = blueGrey[700];

const useStyles = makeStyles({
  buttonRoot: {
    background: 'white',
    height: 43,
  },
  buttonSelected: {
    background: `${highlightColor} !important`,
    color: '#fff !important',
    '&:hover': {
      background: `${highlightColor} !important`,
    },
  },
  groupRoot: {
    height: 43,
  },
});

const PreviewToggle = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { userIsPreviewing, userCanEdit } = useRailsContextApolloData();
  const [setEditPreview, { loading }] = useMutation(SET_EDIT_PREVIEW, {
    onError: toastServerError,
    onCompleted: ({ setEditPreview }) => {
      dispatch({
        type: 'all/railsContext/UPDATE_IS_PREVIEWING_WEBSITE_FULFILLED',
        payload: {
          data: { is_previewing_website: setEditPreview.userIsPreviewing },
        },
      });
    },
    update: (cache, result) => {
      cache.writeQuery({
        query: gql`
          query {
            userIsPreviewing
          }
        `,
        data: {
          userIsPreviewing: result.data.setEditPreview.userIsPreviewing,
        },
      });
    },
  });

  if (!userCanEdit) return null;

  const isPreviewingValue = userIsPreviewing ? 'preview' : 'edit';

  const handleToggleChange = (event, value) => {
    setEditPreview({ variables: { userIsPreviewing: value === 'preview' } });
  };

  return (
    <React.Fragment>
      <ToggleButtonGroup
        value={isPreviewingValue}
        exclusive
        onChange={handleToggleChange}
        classes={{
          root: classes.groupRoot,
        }}
      >
        <ToggleButton
          value="edit"
          disabled={isPreviewingValue === 'edit'}
          classes={{
            root: classes.buttonRoot,
            selected: classes.buttonSelected,
          }}
        >
          {isPreviewingValue === 'edit' && '✓ '}Edit
        </ToggleButton>
        <ToggleButton
          value="preview"
          disabled={isPreviewingValue === 'preview'}
          classes={{
            root: classes.buttonRoot,
            selected: classes.buttonSelected,
          }}
        >
          {isPreviewingValue === 'preview' && '✓ '}Preview
        </ToggleButton>
      </ToggleButtonGroup>
      {loading && <CircularLoading />}
    </React.Fragment>
  );
};

export default PreviewToggle;
